export const LANGUAGE_LOCAL_STORAGE_KEY = 'language';
export const THEME_LOCAL_STORAGE_KEY = 'theme';
export const AGREEMENT_BANNER_STORAGE_KEY = 'agreement-banner';
